module.exports = __webpack_public_path__ + "static/media/Mediamodifier-Design.8ecc8322.svg";